import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Validators } from "@angular/forms";
import { AuthenticationService, Logger } from "@app/core";
import { BaseControl, ConfirmComponent, Const, SeriePredeterminada, Static } from "@app/shared/index";
import { find } from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { FilingStructureConfigService } from "./shared/filing-structure-config.service";
import { FilingStructureFormService } from "./shared/filing-structure-form.service";
import { Consecutive, EstructuraRadicado, FilingStructureDataService, Parametro } from "./shared/filing-structure.data.service";

const log = new Logger("ConsecutiveManagementComponent");

@Component({
  selector: "iw-filing-structure",
  templateUrl: "./filing-structure.component.html",
  styleUrls: ["./filing-structure.component.scss"],
  providers: [FilingStructureFormService, FilingStructureDataService],
})
export class FilingStructureComponent implements OnInit {
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
    detail: true,
  };
  // variable donde se configura las opciones de la tabla
  settings = {};
  // Configuraciones de la tabla secundaria
  settingsSecundary = {};
  // Configuraciones de la tabla de la modal
  settingsModal = {};
  // Define cuando mostrar la tabla principal o el formulario de la modal
  formOpenModal = false;
  // Define si la serie en accion es para editar o agregar
  serieEdit = true;
  // Define si se muestra el control de fechas o no
  restart_date = false;
  // Define la accion a realizar en el formulario
  actionForm = "";
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene los controles suprimidos cuando el checkbox es false
  controlsDeleted: BaseControl<any>[] = [];
  // Contiene los controles de agregar/modificar serie, subserie y tipo documental
  serieSubDocControl: BaseControl<any>[] = [];
  // Pregunta de la modal de confirmaciones
  question = "";
  //modal
  modalRef: BsModalRef;
  // estructura de radicado seleccionada para editar
  selectedRadicade: any;
  // Controla que se haga una eliminación de la primera tabla
  deleteStructure: any;
  // Controla la serie, subserie y tipo documental seleccionado para modificar
  selectedSerieSubDoc: any;
  // se utiliza para setear los datos en formato de la libreria de la tabla
  // para poder realizar el filtro general
  source: LocalDataSource;
  sourceSecundary: LocalDataSource;
  sourceModal: LocalDataSource;
  // Formulario de agregar o modificar
  form: BaseControl<any>[] = [];
  //nombre de la estructura para editar
  name = "";
  //Modelo para la selección del tipo 
  typeModel: any;
  //Lista de valores de estructura para eliminar 
  deleteValues: any[] = [];
  // Estructura para modificar
  structure: EstructuraRadicado = {};
  //Habilita o deshabilita el botón de guardar cambios y los inputs de nombre y estructura
  disabled = true;
  //Estructura del radicado
  radicadeStructure = {};
  //modelo para controlar el requerido del selector de consecutivos
  consecutiveRequired = false;
  //modelo para controlar el requerido del selector de busquedas disponibles
  searchRequired = false;
  //Referencia al modal personalizado
  @ViewChild("modalDetail") modalDetail: any;
  // Referencia al componente de confirmación
  @ViewChild("confirm") private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  // Referencia a la modal de agregar o modificar alias, consecutivo y tipo
  @ViewChild("modalTmpltAddModdify") modalTmpltAddModdify: TemplateRef<any>;
  // Referencia al control de la template de modificar o agregar alias, consecutivo y tipo
  @ViewChild("modalTmpltSecundary") modalTmpltSecundary: TemplateRef<any>;
  // Referencia al control de la template de modificar o agregar alias, consecutivo y tipo
  @ViewChild("modalTmpltSearch") modalTmpltSearch: TemplateRef<any>;
  // Referencia al control de la template de modificar o agregar alias, consecutivo y tipo
  @ViewChild("modalTmpltTertiary") modalTmpltTertiary: TemplateRef<any>;
  //Referecia al control de editar o modificar
  @ViewChild("ngSelectDataTable") ngSelectDataTable: TemplateRef<any>;
  // Referencia al control de series
  @ViewChild("serieControl") serieControl: TemplateRef<any>;
  // Referencia al control de subseries
  @ViewChild("subserieControl") subserieControl: TemplateRef<any>;
  // Referencia al control de tipo documental
  @ViewChild("typeDocControl") typeDocControl: TemplateRef<any>;
  //Referencia al modal de modificar o agregar
  @ViewChild('modalAddModify') modalAddModify: any;
  //Datos para llenar la tabla inicial
  dataTable: EstructuraRadicado[] = [];
  //Datos para llenar la tabla secundaria
  dataTableSecundary: Parametro[] = [];
  // Datos para llenar la tabla de la modal
  dataTableModal: any[] = []
  // Detalles de la estructura
  details: EstructuraRadicado;
  //Consecutivos disponibles
  consecutivos: Consecutive[] = [];
  //Busquedas disponibles
  searchs: any[] = [];
  //Tipos disponibles
  tipos: any[] = [];
  //series disponibles
  @Input() series: SeriePredeterminada[] = [];
  // Subseries disponibles
  @Input() subseries: any[] = [];
  // Lista de subseries a mostrar
  subseriesList: any[] = [];
  // Lista de tipos documentales
  typeDocumentaryList: any[] = [];
  //tipos documentales disponibles
  @Input() typeDocumentary: any[] = [];
  // id de la subserie seleccionada
  idSubSerieSelect: any;
  // Id del tipo documental seleccionado
  idTypeDocumentary: any;

  constructor(
    private as: AuthenticationService,
    private toastr: ToastrService,
    private modal: BsModalService,
    private fsfs: FilingStructureFormService,
    private fsds: FilingStructureDataService
  ) {
    
  }

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.delete
    );
    this.activateAction.detail = true;
    const configTable = new FilingStructureConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
    //configuración de la tabla secundaria
    this.settingsSecundary = configTable.settingsSecondTable;
    configTable.actionTable.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionSecundary(res.action, res.data);
    });
    // Configuración de la tabla de la modal
    this.settingsModal = configTable.settingsModal;
    configTable.actionModal.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionsModal(res.action, res.data);
    });
    this.sourceSecundary = new LocalDataSource(this.dataTableSecundary);
    // Obtener las estructuras
    this.getStructures();
  }

  /**
   *Consulta las estructuras de radicados
   *
   * @memberof FilingStructureComponent
   */
  getStructures() {
    this.fsds.getStructures().subscribe(async res => {
      if(res){
        this.dataTable = await res;
        this.dataTable.forEach((data) => {
          data["detail"] = false;
        });
        this.source = new LocalDataSource(this.dataTable);
      }
    });    
  }

  /**
   *Obtiene los valores de la estructura del radicado
   *Obtiene los tipos de estructuras
   * @memberof FilingStructureComponent
   */
  getStructureValues(id: number){
    this.fsds.getValues(id).subscribe(async res =>{
      if(res){
        this.structure = await res;
        this.dataTableSecundary = await this.structure.parametros;
        this.dataTableSecundary.forEach((data) => {
          data['marca'] = 'existente'
          data["detail"] = true;
        });
        this.sourceSecundary = new LocalDataSource(this.dataTableSecundary);
      }
    });

    this.getTypesConsecutives();
  }

  /**
   *Obtiene los tipos y los consecutivos
   *
   * @memberof FilingStructureComponent
   */
  getTypesConsecutives(){
    this.fsds.getStructureTypes().subscribe(async (data) => {
      if(data){
        this.tipos = await data;
      }
    })

    this.fsds.getConsecutives().subscribe(async (data) => {
      if(data){
        this.consecutivos = await data;
        this.consecutivos.forEach((consecutive=>{
          consecutive['label'] = "Id: " + consecutive.id + "/ Número de consecutivo: " + consecutive.consecutivo + 
          "/ Fecha de último reinicio: " + consecutive.fecha_reinicio
        }));
      }
    });

    this.fsds.getSearchStructure().subscribe(async (data) => {
      if(data){
        this.searchs = await data;
      }
    });
  }

  /**
   * Condiciona acción a realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof FilingStructureComponent
   */
  defineActionCondictions(action: "add" | "update" | "detail" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.getTypesConsecutives();
          this.dataTableSecundary.length = 0;
          this.formOpen = true;
          this.serieEdit = false;
          this.formOpenModal = false;
          this.disabled = true;
          this.name = "";
          this.structure = null;
          this.actionForm = "Agregar";
          this.form = this.getControlEditForm({
            dataTypeahead: [],
            ngSelectTmpl: this.ngSelectDataTable,
          });
        } else {
          this.toastr.error("Usted no posee permisos para agregar consecutivos al sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.structure = data;
          this.getStructureValues(this.structure.id)
          this.formOpen = true;
          this.formOpenModal = false;
          this.serieEdit = true;
          this.name = data.nombre;
          this.disabled = false;
          this.actionForm = "Modificar";
          this.form = this.getControlEditForm({
            dataTypeahead: [],
            ngSelectTmpl: this.ngSelectDataTable,
            data,
          });
        } else {
          this.toastr.error("Usted no posee permisos para modificar los consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.deleteStructure = data;
          this.question = '¿Realmente desea eliminar la serie?';
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "detail":
        if (this.activateAction.detail) {
          this.formOpen = false;
          this.formOpenModal = true;
          this.structure = data;
          this.getDetails(this.structure.id);
          this.modalRef = this.modal.show(this.modalDetail, {
            class: "modal-lg-personalized",
            ignoreBackdropClick: true,
          });
        } else {
          this.toastr.error("Usted no posee permisos para ver el detalle del consecutivo", "Permiso denegado");
        }
        break;
    }
  }

  /**
   * Condiciona acción a realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof FilingStructureComponent
   */
   defineActionSecundary(action: "add" | "update" | "delete" = "add", data?: Parametro) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.formOpen = true;
          this.serieEdit = true;
          this.actionForm = "Agregar";
          this.controls = this.getControlsFormBasic({
            dataTypeahead: [],
            modalTmpltSecundary: this.modalTmpltSecundary,
            modalTmpltTertiary: this.modalTmpltTertiary,
            modalTmpltSearch: this.modalTmpltSearch
          });
          this.openModal();
        } else {
          this.toastr.error("Usted no posee permisos para agregar consecutivos al sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.controls = this.getControlsFormBasic({
            dataTypeahead: [],
            modalTmpltSecundary: this.modalTmpltSecundary,
            modalTmpltTertiary: this.modalTmpltTertiary,
            modalTmpltSearch: this.modalTmpltSearch,
            data,
          });
          this.selectedRadicade = data;
          this.openModal();
          this.actionForm = "Modificar";
        } else {
          this.toastr.error("Usted no posee permisos para modificar los consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.selectedRadicade = data;
          this.question = "¿Realmente desea eliminar la estructura del radicado?";
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar consecutivos del sistema", "Permiso denegado");
        }
        break;
    }
  }

  /**
   * Condiciona acción a realzar en la modal
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof FilingStructureComponent
   */
   defineActionsModal(action: "add" | "update" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.actionForm = "Agregar";
          this.serieSubDocControl = this.getSerieSubDocForm({
            dataTypeahead: [],
            serieTmplt: this.serieControl,
            subserieTmpl: this.subserieControl,
            typeDocTmpl: this.typeDocControl
          });
          this.openAddModal();
        } else {
          this.toastr.error("Usted no posee permisos para agregar consecutivos al sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.formatSelectors(data.id_serie, data.id_subserie, data.id_tipo_documental);
          this.serieSubDocControl = this.getSerieSubDocForm({
            dataTypeahead: [],
            serieTmplt: this.serieControl,
            subserieTmpl: this.subserieControl,
            typeDocTmpl: this.typeDocControl, 
            data
          });
          this.selectedSerieSubDoc = data;
          this.openAddModal();
          this.actionForm = "Modificar";
        } else {
          this.toastr.error("Usted no posee permisos para modificar los consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.selectedSerieSubDoc = data;
          this.question = "¿Realmente desea eliminar la estructura?";
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar consecutivos del sistema", "Permiso denegado");
        }
        break;
    }
  }

  
   /**
    **Método que llena los selectores cuando hay una edición
   *Solo funciona en este caso específico
    *
    * @param {number} idSerie
    * @param {number} [idSubserie]
    * @param {number} [idDocumentary]
    * @memberof FilingStructureComponent
    */
   formatSelectors(idSerie: number, idSubserie?: number, idDocumentary?: number){
    this.subseriesList.length = 0
    this.subseriesList = [...this.subseriesList];
    this.typeDocumentaryList.length = 0;
    this.typeDocumentaryList = [...this.typeDocumentaryList];
    this.subseries.forEach(subseries =>{
      if(subseries.serie.id == idSerie){
        this.subseriesList = [...this.subseriesList, subseries];
      }
    });
    if(idSubserie){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = idSubserie;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }
    if(idDocumentary){
      this.idTypeDocumentary = idDocumentary;
    }
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof FilingStructureComponent
   */
  getControlsFormBasic(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.fsfs.getFormRadicade(objectModel) : this.fsfs.getFormRadicade();
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof FilingStructureComponent
   */
   getSerieSubDocForm(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.fsfs.getSerieSubDoc(objectModel) : this.fsfs.getSerieSubDoc();
  }

  /**
   *Obtiene los detalles de la estructura de radicado
   *
   * @memberof FilingStructureComponent
   */
  getDetails(id: number) {
    this.fsds.getDetails(id).subscribe(async res=>{
      if(res){
        this.details = await res;
        this.dataTableModal = await this.details.detalle;
        this.dataTableModal.forEach(data=>{
          data['detail'] = true;
        })
        this.sourceModal = new LocalDataSource(this.dataTableModal);
      }
    }); 
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof FilingStructureComponent
   */
  getControlEditForm(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.fsfs.getFormEdit(objectModel) : this.fsfs.getFormEdit();
  }

  /**
   * Cierra la vista del formulario de creación o edición de un radicado
   *
   * @memberof FilingStructureComponent
   */
  closeFormSerie() {
    this.actionForm = "";
    this.question = "";
    this.formOpen = false;
    this.serieEdit = false;
    this.dataTableSecundary.length = 0;
    this.sourceSecundary.refresh();
  }

  /**
   *Inicializa el formulario de editar nombre y/o estructura
   *
   * @memberof FilingStructureComponent
   */
  setForm() {
    this.form = this.getControlEditForm();
  }

  /**
   *Cierra la modal
   *
   * @memberof FilingStructureComponent
   */
  closeModal() {
    this.modalRef.hide();
    this.typeModel = null;
  }

  /**
   *Cierra la modal de agregar
   *
   * @memberof FilingStructureComponent
   */
  closeAddModal(){
    this.idSubSerieSelect = null;
    this.idTypeDocumentary = null;
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }

  /**
   *
   *Abre la modal de agregar o modificar alias, consecutivo y tipo
   * @memberof FilingStructureComponent
   */
  openModal() {
    this.modalRef = this.modal.show(this.modalTmpltAddModdify, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }

  /**
   *Actualiza el requerido del consecutivo según la selección del tipo
   *
   * @param {*} data
   * @memberof FilingStructureComponent
   */
  changeType(data: any){
    if(data){
      if(data.id == 8){
        this.consecutiveRequired = true;
      }else{
        this.consecutiveRequired = false;
      }
    }else{
      this.consecutiveRequired = false;
    }
    // this.controls.get('tipo').updateValueAndValidity()
  }

  /**
   *Abre la modal de agregar, eliminar o modificar serie, subserio y tipo documental
   *
   * @memberof FilingStructureComponent
   */
  openAddModal(){
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalAddModify, { class: "modal-lg-personalized", ignoreBackdropClick: true });
  }

  /**
   *Obtiene los cambios realizados en el formulario de agregar/modificar
   *
   * @param {*} data
   * @memberof FilingStructureComponent
   */
  saveNewRadicade(data: any) {
    if (this.selectedRadicade && this.structure) {
      let tempConsulta: any = null;
      if(data.consulta){
        let consultaResult = find(this.searchs,{id:data.consulta});
        if(consultaResult){
          tempConsulta = consultaResult.nombre;
        }
      }
      
      let radicade = {
        id: this.selectedRadicade.id,
        alias: data.alias,
        consecutivo: data.consecutivo,
        consulta: data.consulta,
        consulta_nombre: tempConsulta,
        digitos: data.digitos,
        tipo: data.tipo,
        tipo_nombre: this.selectedRadicade.tipo_nombre,
      };
      this.tipos.forEach((tipo) =>{
        if(tipo.id == data.tipo){
          radicade.tipo_nombre = tipo.nombre;
        }
      });
      let exist;
      let index;
      this.dataTableSecundary.forEach((dts, i)=>{
        if(dts.id == this.selectedRadicade.id && this.selectedRadicade.marca == 'agregar'){
          exist = true;
          index = i;
        }
      });
      if(exist){
        radicade['marca'] = 'agregar';
        this.dataTableSecundary.splice(index, 1, radicade);
      }else{
        radicade['accion'] = "modificar";
        radicade['marca'] = "modificar";
        let index = this.dataTableSecundary.indexOf(this.selectedRadicade);
        this.dataTableSecundary.splice(index, 1, radicade);
      }
    }
    else if(this.structure && !this.selectedRadicade){
      let tempConsulta: any = null;
      if(data.consulta){
        let consultaResult = find(this.searchs,{id:data.consulta});
        if(consultaResult){
          tempConsulta = consultaResult.nombre;
        }
      }
      let radicade = {
        alias: data.alias,
        consecutivo: data.consecutivo,
        consulta: data.consulta,
        consulta_nombre: tempConsulta,
        tipo: data.tipo,
        digitos: data.digitos,
        marca: 'agregar'
      };
      this.tipos.forEach((tipo) =>{
        if(tipo.id == data.tipo){
          radicade['tipo_nombre'] = tipo.nombre;
        }
      });
      this.dataTableSecundary.push(radicade);
    }else{
      let tempConsulta: any = null;
      if(data.consulta){
        let consultaResult = find(this.searchs,{id:data.consulta});
        if(consultaResult){
          tempConsulta = consultaResult.nombre;
        }
      }
      let radicade = {
        alias: data.alias,
        consecutivo: data.consecutivo,
        consulta: data.consulta,
        consulta_nombre: tempConsulta,
        tipo: data.tipo,
        digitos: data.digitos,
        marca: 'agregar'
      };
      this.tipos.forEach((tipo) =>{
        if(tipo.id == data.tipo){
          radicade['tipo_nombre'] = tipo.nombre;
        }
      });
      this.dataTableSecundary.push(radicade);
    }
    this.selectedRadicade = null;
    this.typeModel = null;
    this.sourceSecundary.refresh();
    this.closeModal();
  }

  /**
   *Modal de confirmación de eliminación
   *
   * @param {boolean} res
   * @memberof FilingStructureComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      if(this.deleteStructure){
        this.fsds.deleteStructure(this.deleteStructure.id).then(res=>{
          if(res) {
            this.getStructures();
          }
        })
        this.deleteStructure = null;
      }else if(this.selectedSerieSubDoc){
        this.fsds.deleteDetail(this.selectedSerieSubDoc.id).then(result =>{
          if(result){
            this.getDetails(this.structure.id);
          }
        });
        this.selectedSerieSubDoc = null;
      }else{
        let index = 0;
        let exist;
        this.dataTableSecundary.forEach((dt, i)=>{
          if(dt.id == this.selectedRadicade.id && dt['marca'] == ('existente' || 'modificar')){
            index = i;
            exist = true;
          }
        });
        if(exist){
          this.dataTableSecundary[index]['accion'] = 'eliminar';
          index = this.dataTableSecundary.indexOf(this.selectedRadicade);
          this.dataTableSecundary.splice(index, 1);
          this.selectedRadicade.marca = 'eliminar'
          this.selectedRadicade['accion'] = 'eliminar'
          this.deleteValues.push(this.selectedRadicade)
        }else{
          index = this.dataTableSecundary.indexOf(this.selectedRadicade);
          this.dataTableSecundary.splice(index, 1);
        }
        this.sourceSecundary.refresh();
        this.selectedRadicade = null;
      }
    }
  }


  /**
   *Gaurda una nueva estructura en el sistema
   *
   * @param {*} data
   * @memberof FilingStructureComponent
   */
  saveNewStructure(data: any) {
    if(this.dataTableSecundary.length){
      if(this.deleteValues.length){
        this.deleteValues.forEach(dlv=>{
          this.dataTableSecundary.push(dlv);
        })
      }
      let structure = {
        nombre: data.name,
        estructura: data.structure,
        parametros: Static.copyObjet(this.dataTableSecundary)
      };
      if (this.structure) {
        this.fsds.updateStructureValues(this.structure.id, structure).then(res=>{
          if(res){
            this.getStructures();
          }
        })
        // let index = this.dataTable.indexOf(this.structure);
        // this.dataTable.splice(index, 1, structure);
      } else {
        // if(this.dataTableSecundary.length){
        //   structure.parametros = Static.copyObjet(this.dataTableSecundary);
        // }
        this.fsds.addStructure(structure).then(result => {
          if(result){
            this.getStructures();
          }
        })
        // this.dataTable.push(structure);
      }
      // this.dataTable.forEach((data) => {
      //   data["detail"] = false;
      // });
      this.formOpen = false;
      this.serieEdit = false;
      this.structure = null;
      this.deleteValues.length = 0;
      this.dataTableSecundary.length = 0;
      // this.source.refresh();
    }else{
      this.toastr.warning('No se permite guardar la estructura sin valores', 'Error en la acción');
    }
  }

  /**
   *Guarda los detalles de la estructura de radicado
   *
   * @param {*} data
   * @memberof FilingStructureComponent
   */
  saveNewSerie(data: any){
    let serie = {
      estructura: this.structure.id,
      serie: data.serie,
      subserie: data.subserie,
      tipo_documental: data.tipo_documental
    }
    if(this.selectedSerieSubDoc){
      this.fsds.updateStructureDetails(this.selectedSerieSubDoc.id, serie).then(result =>{
        if(result){
          this.getDetails(this.structure.id);
        }
      });
      // let index = this.dataTableModal.indexOf(this.selectedSerieSubDoc);
      // this.dataTableModal.splice(index, 1, serie);
    }else {
      this.fsds.addDetail(serie).then(res =>{
        if(res){
          this.getDetails(this.structure.id);
        }
      })
      // this.dataTableModal.push(serie);
    }
    // this.sourceModal.refresh();
    this.selectedSerieSubDoc = null;
    this.closeAddModal();
  }

  /**
   *Obtiene los cambios en los selectores de serie, subserie y tipo documental
   *
   * @param {*} data
   * @param {string} type
   * @memberof FilingStructureComponent
   */
  changeForm(data: any, type: string) {
    if(type=="serie" && data !== undefined){
      this.subseriesList.length = 0
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.subseries.forEach(subseries =>{
        if(subseries.serie.id == data.id){
          this.subseriesList = [...this.subseriesList, subseries];
        }
      });
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }else if(type=="serie" && data == undefined) {
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }

    if(type=="subserie" && data !== undefined){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }else if(type=="subserie" && data == undefined) {
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/filing-structure/filing-structure.component.ts